module.exports = __webpack_public_path__ + "media/images/dublicate-3cc80e170fe600c7c96239d0a06333fc.png";